import BrowseJobsAPI from "../Apis/BrowseJobsApi";
import toList from "../utils/ComponentUtil";
import CustomTabs from "../utils/CustomTabs";
import Header from "../utils/Header";
import useWindowDimensions from "../utils/WindowDimensions";
import FeatureCard from "./FeatureCard";
import "./FeatureCard.scss";

function FeaturesProvided() {
    let features = BrowseJobsAPI.featuresProvided;
    const { width } = useWindowDimensions();
    const isMobile = () => { return width <= 768; }
    return (
        <div className="features-provided wrapper" >
            <Header title={'Feature We Provide'} subTitle={'Sign up for Free. Simply post what'} />
            <CustomTabs tabs={[
                {
                    label: 'Freelancers',
                    component: <div className="features">
                        {toList(features?.freelancers, FeatureCard)}
                    </div>
                },
                {
                    label: 'Employers',
                    component: <div className="features">
                        {toList(features?.employers, FeatureCard)}
                    </div>
                }]} />
        </div>
    );
}

export default FeaturesProvided;